import { Component, OnInit } from '@angular/core';
import {CallRangeAllowedComponent} from '../../call-range-allowed/call-range-allowed.component';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';
import {VnaPortalConfigDataParserService} from '../../../../vna_portal/services/vna-portal-config-data-parser.service';
import {MiscelaneaService} from '../../../../../../shared/services/miscelanea.service';
import {AlertaService} from '../../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-chacon-smscall-range-allowed',
  templateUrl: './chacon-smscall-range-allowed.component.html',
  styleUrls: ['./chacon-smscall-range-allowed.component.scss']
})
export class ChaconSmscallRangeAllowedComponent extends CallRangeAllowedComponent implements OnInit {

    constructor(protected formBuilder: FormBuilder, protected portalServiceFactory: PortalServiceFactoryService, protected dataParser: VnaPortalConfigDataParserService, protected miscHandler: MiscelaneaService, protected alertHandler: AlertaService) {
        super(formBuilder, portalServiceFactory, dataParser, miscHandler, alertHandler);
    }

    ngOnInit() {
        super.ngOnInit();
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/chacon-sms/chacon-smscall-range-allowed/chacon-smscall-range-allowed.component.ts